<template>
    <div class="cardLanding py-3 px-2">
        <vs-row>
            <vs-col w="5" class="objetfit">
                    <img :src="'/api/personas/' + personaId + '/avatar'" @error="setAltImg" alt="">
            </vs-col>
            <vs-col w="7" class="pl-3">
                <h5><strong>{{info.nombre}}</strong></h5>
                <p class="mb-0"><i><small>MATRÍCULA</small></i></p>
                <p>{{info.matricula}}</p>
            </vs-col>
        </vs-row>
        <md-divider class="my-3"></md-divider>
        <vs-row>
            <vs-col w="12" v-if="info.secciones">
                <h6><strong>REGISTRO ACADÉMICO ACTUAL</strong></h6>
                <p class="mb-0"><small>INSTITUCIÓN</small></p>
                <p><strong>{{info.secciones.registro_actual.institucion}}</strong></p>
                <p class="mb-0"><small>CICLO ESCOLAR</small></p>
                <p><strong>{{info.secciones.registro_actual.ciclo_escolar}}</strong></p>
                <p class="mb-0"><small>PROGRAMA</small></p>
                <p><strong>{{info.secciones.registro_actual.programa}}</strong></p>
                <p class="mb-0"><small>GRADO</small></p>
                <p><strong>{{info.secciones.registro_actual.grado}}</strong></p>
                <p class="mb-0"><small>GRUPO ADMINISTRATIVO (No.Lista)</small></p>
                <p><strong>{{info.grupo_administrativo}}</strong></p>
            </vs-col>
        </vs-row>
        <md-divider class="my-4"></md-divider>
        <vs-row>
            <vs-col w="12" v-if="info.secciones">
                <h6><strong>DATOS FISCALES</strong></h6>
                <p class="mb-0"><small>RFC</small></p>
                <p style="text-transform: uppercase;">
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.rfc"><strong>{{info.secciones.fiscales.rfc}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
                <p class="mb-0"><small>RAZÓN SOCIAL</small></p>
                <p>
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.razon_social"><strong>{{info.secciones.fiscales.razon_social}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
                <p class="mb-0 mayusculas"><small>Correo fiscal</small></p>
                <p>
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.razon_social"><strong>{{info.secciones.fiscales.correo_fiscal}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
                <p class="mb-0"><small>Uso de CFDI</small></p>
                <p>
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.uso_cfdi"><strong>{{info.secciones.fiscales.uso_cfdi}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
                <p class="mb-0"><small>CURP</small></p>
                <p>
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.curp"><strong>{{info.secciones.fiscales.curp}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
                <p class="mb-0"><small>CURP</small></p>
                <p>
                    <span v-if="info && info.secciones && info.secciones.fiscales && info.secciones.fiscales.curp"><strong>{{info.secciones.fiscales.curp}}</strong></span>
                    <span v-else><strong>Sin información</strong></span>
                </p>
            </vs-col>
        </vs-row>
        <md-divider class="my-4"></md-divider>
        <vs-row>
            <vs-col w="12" v-if="info.secciones">
                <h6 class="mayusculas"><strong>Becas</strong></h6>
                <div v-for="(becas, i) in info.secciones.becas" :key="i">
                    <p class="mb-0"><small>Status: </small><strong><span style="text-transform: capitalize;">{{becas.status}}</span></strong></p>
                    <p class="mb-0">{{becas.ciclo_escolar}}</p>
                    <p style="text-transform: uppercase;"><strong>{{becas.nombre}}</strong></p>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import profesor from '../../../api/requests/landing-profesor'
export default {
    props:[
        'personaId',
        'institucion',
        'cicloEscolar',
        'programa',
        'permisosInfo'
    ],
    data(){
        return{
            ruta: '',
            host: '',
            info: [],
            optCfdi:{
                'G01': {'text': 'Adquisición de Mercancías'},
                'G02': {'text': 'Devoluciones, Descuentos o Bonificaciones'},
                'G03': {'text': 'Gastos en General'},
                'I01': {'text': 'Construcciones'},
                'I02': {'text': 'Mobiliario y Equipo de Oficina por Inversiones'},
                'I03': {'text': 'Equipo de Transporte'},
                'I04': {'text': 'Equipo de Cómputo y Accesorios'},
                'I05': {'text': 'Dados, Troqueles, Moldes, Matrices y Herramental'},
                'I06': {'text': 'Comunicaciones Telefónicas'},
                'I07': {'text': 'Comunicaciones Satelitales'},
                'I08': {'text': 'Otra Maquinaria y Equipo'},
                'D01': {'text': 'Honorarios Médicos, Dentales y Gastos Hospitalarios'},
                'D02': {'text': 'Gastos Médicos por Incapacidad o Discapacidad'},
                'D03': {'text': 'Gastos Funerales'},
                'D04': {'text': 'Donativos'},
                'D05': {'text': 'Intereses Reales Efectivamente Pagados por Créditos Hipotecarios (Casa Habitación)'},
                'D06': {'text': 'Aportaciones Voluntarias al SAR'},
                'D07': {'text': 'Primas por Seguros de Gastos Médicos'},
                'D08': {'text': 'Gastos de Transportación Escolar Obligatoria'},
                'D09': {'text': 'Depósitos en Cuentas para el Ahorro, Primas que tengan como Base Planes de Pensiones'},
                'D10': {'text': 'Pagos por Servicios Educativos (Colegiaturas)'},
                'P01': {'text': 'Por Definir'}
            },
            facturacion: {
                "0": {
                    "text": "No"
                },
                "1":{
                    "text": "si"
                }
            },
            cargos_parcializados: false
        }
    },
    created(){
        this.ruta = window.location.protocol
        this.host = window.location.host
    },
    methods:{
        replaceByDefault(e){
            e.target.src = 'https://sigem.maristas.mx/img/default-avatar.jpg'
        },
        async getInfo () {
            if (this.programa){
                try {
                    let seccion = []
                    // if (this.permisosInfo.includes('ver-registro-academico-actual-gestion'))
                        seccion.push('registro_actual')

                    // if (this.permisosInfo.includes('ver-tutor-gestion')){
                        seccion.push('tutor')

                    // if (this.permisosInfo.includes('ver-datos-fiscales-gestion'))
                        seccion.push('fiscales')

                    // if (this.permisosInfo.includes('ver-becas-gestion'))
                        seccion.push('becas')
                    
                    const params = {
                        "id": this.personaId,
                        "secciones": seccion,
                        "institucion_id": this.institucion,
                        "ciclo_escolar_id": this.cicloEscolar,
                        "programa_id": this.programa
                    }

                    const {data: response} = await profesor.getInfoPersona(params)
                    this.info = response
                    this.cargos_parcializados = response.cargos_parcializados
                    
                  this.$emit('refreshTable',this.cargos_parcializados)
                } catch (error) {
                    console.log(error)
                }
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
    watch:{
        cicloEscolar(){
            if(this.programa){
                this.getInfo()
            }
        },
        programa(){
            this.getInfo()
        }
    }
}
</script>

<style scoped>
    .objetfit > img{
        width: 100%;
        height: 135px;
        border-radius: 50%;
        object-fit: cover;
    }
    .mayusculas{
        text-transform: uppercase;
    }
</style>
